import axios from 'axios';
import { microServicesURLs } from './axios';

export const getVersionAPI = async () => {
  const response = await axios.get(`${microServicesURLs.DE_CORE}/version`, {
    withCredentials: true,
    headers: { 'x-client-type': 'web' }
  });
  return response.data;
};
